import { useEffect, useState } from 'react';
import timesheetService from '../../../services/TimesheetService';
import { getFormattedTableRows } from '../table/helpers';
import { addDays, format } from 'date-fns';

export default function useFetchEmployeeTimesheet(filter) {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchEmployeeTimesheet = async () => {
      try {
        setError(null);
        setLoading(true);

        const timesheetList = await timesheetService.listEmployeeTimesheet();

        const formattedRows = getFormattedTableRows(timesheetList.data.data);

        const filteredRows = formattedRows.filter((r) => {
          if (filter.timesheetPeriod === 'All') return true;

          if (
            (filter.startDate === null || new Date(r.Date) >= new Date(filter.startDate).getTime()) &&
            new Date(r.Date) <= addDays(new Date(filter.endDate), 1).getTime()
          ) {
            return true;
          }

          return false;
        });

        const dateFormattedRows = filteredRows.map((r) => {
          return {
            ...r,
            Day: format(new Date(r.Date), 'EEEE'),
            Date: format(new Date(r.Date), 'dd/MM/yyyy')
          };
        });

        const searchedRows = searchRows(dateFormattedRows, filter.searchQuery);

        const dateFormatSearchedRows = searchedRows.map((sr) => {
          const matchedRow = filteredRows.find((fr) => fr.id === sr.id);

          if (matchedRow) {
            return { ...sr, Date: matchedRow.Date };
          } else {
            return sr;
          }
        });

        setRows(dateFormatSearchedRows);
      } catch (e) {
        setError(e.message || 'Could not fetch timesheet data');
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeeTimesheet();
  }, [filter.endDate, filter.startDate, filter.timesheetPeriod, filter.searchQuery]);
  return { rows, setRows, error, loading };
}

function searchRows(allRows, query) {
  const normalizedQuery = query.trim().toLowerCase();
  const containsQuery = (value) =>
    String(value ?? '')
      .toLowerCase()
      .includes(normalizedQuery);

  const searchedRows = allRows.filter((r) => {
    return (
      containsQuery(r.Date) ||
      containsQuery(r.Day) ||
      containsQuery(r.CustomerRef?.name) ||
      containsQuery(r.EmployeeRef?.name) ||
      containsQuery(r.status) ||
      containsQuery(r.variationNote) ||
      containsQuery(r.Description) ||
      containsQuery(r.ClassRef?.name) ||
      containsQuery(r.VendorRef?.name)
    );
  });

  return searchedRows;
}
